import React from "react";

export default function SendEmails(){
    return(<h1>Email Sender</h1>)
}